
import { defineComponent } from "vue";

export default defineComponent({
  name: "InfoIcon",
  emits: ["toggle-info"],
  setup(_, { emit }) {
    const toggleInfo = () => {
      emit("toggle-info");
    };

    return {
      toggleInfo,
    };
  },
});
